import axios from 'axios'
import urlGenerator from './url-generator'
import { property } from 'lodash'
import createRequestConfig from './create-request-config'
import QuerystringBuilder from '../../utilities/querystring-builder'

const fetchData = ({
    limit = 10,
    offset = 0,
    searchString,
    recipientId,
    authorId,
}) => {
    const queryString = new QuerystringBuilder()
    let url = urlGenerator.messages()
    queryString.addParam('limit', limit)
    queryString.addParam('offset', offset)
    queryString.addParam('s', searchString)
    queryString.addParam('r', recipientId)
    queryString.addParam('a', authorId)
    return axios.get(url + queryString.toString(), createRequestConfig()).then(property('data'))
}

export default fetchData